import { Injectable } from '@angular/core'

/**
 * Returns the global document object.
 */
const getDocument = () => window.document

@Injectable({
  providedIn: 'root',
})
export class DocumentRefService {
  /**
   * Returns the global document object.
   */
  public get document() {
    return getDocument()
  }
}
